<template>
  <div class="reply-container">
    <div class="reply-container_inner">
      <div class="reply-container_inner_title">
        <span class="reply-container_inner_title-headline">{{user.headline}}</span>
        <span class="reply-container_inner_title-handle">@{{user.handle}}</span>
      </div>
      <div class="reply-container_inner_message">
        <div v-if="msg.msg_type === 'text'">{{msg.message}}</div>
        <div class="reply-container_inner_message-photo" v-else-if="msg.msg_type === 'image'" :style="{'background-image': 'url(' + getImagePath(msg) + ')' }"></div>
        <div class="reply-container_inner_message-video" v-else-if="msg.msg_type === 'video'" :style="{'background': 'url(' + (msg.thumbnail_gif || msg.thumbnail_img) + ') center / cover' }"></div>
        <div class="reply-container_inner_message-location" v-else-if="msg.msg_type === 'location'" :style="{'background-image': 'url(/main/img/icons/message-location-' + (msg.user_from === currentUserId ? 'outcomming' : 'incomming') + '.svg?ver=2)' }"></div>
      </div>
    </div>
    <div
        @keydown.enter.shift.exact.prevent
        @keydown.enter.shift.exact="close({'chatMode' : msg.channel,'eventId' : eventId,'userId' : interlocutorId})"
        class="reply-container_close" @click="close({'chatMode' : msg.channel,'eventId' : eventId,'userId' : interlocutorId})">
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions, mapMutations} from 'vuex'
import chatModule from '@chat/module/store/type'
import auth from '@general/lib/auth';

export default {
    props: ['msg','user','interlocutorId','eventId'],

    mixins: [
      require('@general/lib/mixin').default
    ],
    computed: {
        ...mapGetters({
        }),
        currentUserId : function (){
          return auth.getUserId()
        }
    },
    methods: {
      ...mapMutations({
        close: chatModule.mutations.replies.remove
      }),
        ...mapActions({
        }),

      getImagePath(message) {
        let imagePath = message.photo_small;
        let path = null
        if (
            imagePath.substr(0, 11) === '/assets/img'
            ||
            imagePath.substr(0, 4) === 'http'
        ){
          path = imagePath
        } else {
          path = `/uploads/users/${imagePath}_orig.jpg`
        }
        return path
      },
    },

  watch: {
  },
  data() {
    return {
    }
  }
}
</script>
